<template>
  <main-layout
    class="bulksales"
    custom-back
    page-title="批量销售农产品"
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="distbox">
        <div class="title">
          <h2>{{ title }}</h2>
          <i class="el-icon-close close" @click="goBackAgriprod"></i>
        </div>
        <div style="display: flex; margin-top: 10px">
          <el-button
            class="preview"
            icon="el-icon-printer"
            plain
            type="primary"
            @click="toPrint"
            >打印
          </el-button>
          <el-select
            v-model="value"
            placeholder="请选择"
            @change="options_change"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div ref="printContent" v-loading="loading" class="dist-list">
          <template>
            <div v-for="(item, i) in pageNum" :key="i">
              <Preview
                :amountTotal="amountTotal"
                :numTotal="numTotal"
                :pageNo="i"
                :tableData="tableData.slice(i * 7, i * 7 + 7)"
                :tableInfo="tableInfo"
                :total="pageNum"
              ></Preview>
              <div v-if="value == 2" class="dashed"></div>
              <Preview
                v-if="value == 2"
                :amountTotal="amountTotal"
                :numTotal="numTotal"
                :pageNo="i"
                :tableData="tableData.slice(i * 7, i * 7 + 7)"
                :tableInfo="tableInfo"
                :total="pageNum"
              ></Preview>
              <div v-if="i + 1 !== pageNum">
                <br />
                <br />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layout/MainLayout";
import Preview from "./compoments/Preview";
import html2canvas from "html2canvas";
import printJS from "print-js";
import { maxDecimalPlaces, getPageParams, dateFormat } from "@/utils";
import { apiSellDetail, apiSellnewDetail } from "@/api/request/snkd.produce.js";
import { SessionStorage } from "@/utils/storage";

export default {
  name: "PreviewBox",
  components: {
    MainLayout,
    Preview,
  },
  data() {
    return {
      value: "1",
      options: [
        {
          value: "1",
          label: "单张预览",
        },
        {
          value: "2",
          label: "多张预览",
        },
      ],
      title: "配货单",
      pageNum: 1,
      loading: false,
      numTotal: 0,
      amountTotal: 0,
      actionUrl: "",
      tableData: [
        {
          amount: "",
          brandName: "",
          cropId: "",
          goodsCode: "",
          goodsName: "",
          money: "",
          productDate: "",
          promptCropName: false,
          promptUnit: false,
          sellPrice: "",
          serialNumber: "",
          specification: "",
          stockAmount: null,
          stockId: "",
          subjectIdentifier: "",
          unit: "",
        },
      ],
      tableInfo: {},
      id: "",
      inoutType: "",
      companyId: "",
      farmId: "",
      upgradeFlag: false,
    };
  },
  async created() {
    const { farm, companyId, inoutType, upgradeFlag, id } = getPageParams();
    this.upgradeFlag = upgradeFlag;
    this.inoutType = inoutType;
    this.farmId = farm;
    this.companyId = companyId;
    if (this.upgradeFlag == 1) {
      let res = await apiSellnewDetail(id);
      this.tableInfo = res.obj;
      this.tableData = res.obj.goodsDetailVO;
      this.value =
        res.obj.goodsDetailVO.length < 7 ||
        res.obj.goodsDetailVO.length < 7 == 7
          ? "2"
          : "1";
      this.tableInfo.sellDate = dateFormat(
        this.tableInfo.sellDate,
        "yyyy-MM-dd"
      );
    } else {
      this.tableInfo = await SessionStorage.get("phd");
      try {
        this.tableData = this.tableInfo.batchSellAdds;
        this.value =
          this.tableInfo.batchSellAdds.length < 7 ||
          this.tableInfo.batchSellAdds.length < 7 == 7
            ? "2"
            : "1";
        this.tableInfo.sellDate = dateFormat(
          this.tableInfo.sellDate,
          "yyyy-MM-dd"
        );
      } catch (e) {
        this.tableInfo = {};
        this.tableData = [
          {
            amount: "",
            brandName: "",
            cropId: "",
            goodsCode: "",
            goodsName: "",
            money: "",
            productDate: "",
            promptCropName: false,
            promptUnit: false,
            sellPrice: "",
            serialNumber: "",
            specification: "",
            stockAmount: null,
            stockId: "",
            subjectIdentifier: "",
            unit: "",
          },
        ];
      }
    }

    this.id = id;

    await this.getPaging();
    await this.toImgGetPrint();
  },
  methods: {
    async options_change() {
      await this.getPaging();
      await this.toImgGetPrint();
    },
    getPaging() {
      this.pageNum = Math.ceil(this.tableData.length / 7);
      this.numTotal = maxDecimalPlaces(
        this.tableData.reduce((prev, cur) => {
          return prev + Number(cur.amount || 0);
        }, 0)
      );
      console.log("numTotal", this.numTotal);
      this.amountTotal = maxDecimalPlaces(
        this.tableData.reduce((prev, cur) => {
          return prev + Number(cur.money || 0);
        }, 0)
      );
      let arr = new Array(this.pageNum * 7 - this.tableData.length).fill("");
      this.tableData.push(...arr);
    },

    //生成图片
    toImgGetPrint() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        allowTaint: false,
        useCORS: true,
        width: this.$refs.printContent.outerWidth,
        height: this.$refs.printContent.outerHeight,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        dpi: window.devicePixelRatio * 2,
      }).then(async (canvas) => {
        // let url = canvas.toDataURL("image/jpeg", 1.0);
        const url = canvas.toDataURL("image/webp", 1);
        this.img = url;
        // 上传图片 base64-->Blob-->FormData
        // this.actionUrl = await this.uploadBase(convertImgDataToBlob(url));
        // this.getApiSellImg(this.actionUrl);
      });
    },
    //根据id获取详情
    async getSellDetail() {
      const res = await apiSellDetail(this.id);
      console.log(res, 8989);
    },
    toPrint() {
      printJS({
        printable: this.img,
        type: "image",
        documentTitle: "打印图片",
        style: `@media print { @page {size: auto; margin: 0; } body{margin:0 5px}}`,
      });
    },
    // 返回上一页
    goBack() {
      window.history.go(-1);
    },
    goBackAgriprod() {
      window.history.go(-2);
    },
  },
  beforeDestroy() {
    SessionStorage.remove("phd");
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  width: 1200px;
  min-height: 100%;
  background: #fff;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  .distbox {
    width: 1000px;
    margin: 0 auto;
    position: relative;

    .preview {
      //position: absolute;
      //top: 60px;
      padding: 12px 40px;
      margin-right: 20px;
    }

    .dist-list {
      overflow: hidden;
      padding-top: 10px;
    }

    .title {
      margin-top: 10px;
      position: relative;
      border-bottom: 1px solid #eeeeee;

      h2 {
        font-size: 22px;
        text-align: center;
        color: #333333;
        line-height: 50px;
      }

      .close {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 22px;
      }
    }
  }
}

.dashed {
  border-bottom: 1px dashed #ccc;
}
</style>
